// https://reactjs.org/docs/hooks-faq.html#is-it-safe-to-omit-functions-from-the-list-of-dependencies
// https://stackoverflow.com/questions/58624200/react-hook-useeffect-has-a-missing-dependency-dispatch
import React, { useEffect } from 'react';
import {
	useLocation,
	useNavigate,
	Routes,
	Route,
	NavLink
} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { MetaContext, useAuth, UserContext, ycStorage } from 'fennec-ui';
import { Layout, Avatar, Tooltip, Menu, Badge, Divider, Dropdown, Modal, Image } from 'antd';
import {
	UserOutlined,
	LogoutOutlined
} from '@ant-design/icons';

import './index.css';
import 'rc-banner-anim/assets/index.css';
import Icofont from 'react-icofont';
import CommonProfile from '../../../desktop/pages/CommonProfile';

import { HasRole } from 'fennec-ui';
import Admin from '../Admin';
import { ycBucket } from '../../../components/Tool';

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;
const { confirm } = Modal;


const compare = (a, b) => {
	return a.replace(" ", "").toLowerCase() === b.replace(" ", "").toLowerCase();
};
const statusForPage = (status, element, onlyNew) => {
	var deep = 1;
	var o = element;
	while (o && o.parent) {
		deep++
		o = o.parent;
	}
	return status.filter((s) => {
		if (onlyNew && s.tipNovayaInfa === false) return false;
		switch (deep) {
			case 1:
				if (element && compare(s.tipMestonakhozhdenieMenyu, element.name)) {
					return true;
				}
				break;
			case 2:
				if (element.parent && compare(s.tipMestonakhozhdenieMenyu, element.parent.name) &&
					element && compare(s.tipMestonakhozhdeniePodMenyu, element.name)) {
					return true;
				}
				break;
			case 3:
				if (element.parent.parent && compare(s.tipMestonakhozhdenieMenyu, element.parent.parent.name) &&
					element.parent && compare(s.tipMestonakhozhdeniePodMenyu, element.parent.name) &&
					element && compare(s.tipMestonakhozhdenieZakladka, element.name)) {
					return true;
				}
				break;
			default:
				return false;
		}
		return false;
	})
};
const notifyForPage = (notify, element, onlyNew) => {
	var deep = 1;
	var o = element;
	while (o && o.parent) {
		deep++
		o = o.parent;
	}
	return notify.filter((s) => {
		if (onlyNew && s.prochitano === true) return false;
		switch (deep) {
			case 1:
				if (element && compare(s.mestonakhozhdenieMenyu, element.name)) {
					return true;
				}
				break;
			case 2:
				if (element.parent && compare(s.mestonakhozhdenieMenyu, element.parent.name) &&
					element && compare(s.mestonakhozhdeniePodMenyu, element.name)) {
					return true;
				}
				break;
			case 3:
				if (element.parent.parent && compare(s.mestonakhozhdenieMenyu, element.parent.parent.name) &&
					element.parent && compare(s.mestonakhozhdeniePodMenyu, element.parent.name) &&
					element && compare(s.mestonakhozhdenieZakladka, element.name)) {
					return true;
				}
				break;
			default:
				return false;
		}
		return false;
	})
};
const menu = (status, notify, role_by_id) => {
	const badge = (element) => {
		var stat = statusForPage(status, element, true);
		var noty = notifyForPage(notify, element, true);
		return {
			count: stat.length + noty.length
		}
	};
	const repack = (menu, role_by_id, parent) => {
		var arr = [];
		for (let i = 0; i < menu.length; i++) {
			const element = menu[i];
			if (element.func) {
				var es = element.func(element, role_by_id);
				if (element.title) {
					var o = {
						uuid: element.uuid,
						path: element.path,
						title: element.title,
						role: element.role,
						group: es.map(e => {
							if (e.menu) {
								e.menu = repack(e.menu, role_by_id);
							}
							e.role = element.role;
							return e
						}),
						badge: badge,
						parent: parent
					};
					if (o.menu) {
						o.menu = repack(o.menu, role_by_id, element);
					}
					arr.push(o);
				} else {
					es.forEach(e => {
						if (e.menu) {
							e.menu = repack(e.menu, role_by_id, element);
						}
						e.role = element.role;
						e.badge = badge;
						e.parent = parent;
						arr.push(e);
					});
				}
			} else {
				if (element.menu) {
					element.menu = repack(element.menu, role_by_id, element);
				}
				element.badge = badge;
				element.parent = parent;
				arr.push(element);
			}
		}
		return arr;
	}
	const x = [
		{
			uuid: "common",
			default: true,
			name: "Общее",
			menu: [
				{
					uuid: "profile",
					default: true,
					name: "Профиль",
					icon: function () {
						return (<UserOutlined />)
					}
				}
			]
		}
	]
	var m = repack(x, role_by_id);
	return m
};
function MenuLevelOne({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		const icon = (element.icon) ? element.icon(element) : <></>;
		if (element.badge && element.badge(element).count > 0) {
			return (
				<Menu.Item key={key}>
					<Badge dot={true} offset={[5, 0]}>
						{icon}{element.name}
					</Badge>
				</Menu.Item>
			)
		}
		return (<Menu.Item key={key}>{element.name}</Menu.Item>)
	})
	const change = ({ key }) => {
		onChange(key, menu);
	}
	return (
		<Menu theme="light" mode="horizontal" style={{ float: 'left' }} onClick={change}
			defaultSelectedKeys={[active]}
			selectedKeys={[active]}>
			{elements}
		</Menu>
	)
}
function MenuLevelTwo({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const style = {
		marginBottom: "0px",
		marginTop: "0px",
		fontSize: "13px",
		paddingRight: "10px"
	}
	const l = (element, key) => {
		const count = (element.badge) ? element.badge(element).count : 0;
		const icon = (element.icon) ? element.icon(element) : <></>;
		return (
			<Menu.Item style={style} key={key}>
				<Tooltip title={element.name} mouseEnterDelay={0.8}>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{icon}{element.name}
						</div>
						<div style={{ width: "37px", textAlign: "right" }}>
							{count > 0 && <Badge color="#ff4d4f" />}
							{/* <Badge count={count} overflowCount={99} /> */}
						</div>
					</div>
				</Tooltip>
			</Menu.Item>
		)
	}
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		if (element.group) {
			const ui = element.group.map(e => {
				return l(e, e.uuid)
			})
			return (
				<SubMenu
					key={element.uuid}
					title={<span style={style}>{element.title}</span>}
					inlineIndent={0}
				>
					{ui}
				</SubMenu>

				// <Menu.ItemGroup title={
				// 	<>
				// 		{/* <Menu.Divider></Menu.Divider> */}
				// 		{element.title && <Divider type="horizontal"
				// 			orientation="left"
				// 			style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				// 			{element.title}
				// 		</Divider>}
				// 	</>} key={key}>
				// 	{ui}
				// </Menu.ItemGroup>
			)
		} else {
			return l(element, key)
		}
	})
	const change = ({ key }) => {
		onChange(key, menu)
	}
	return (
		<>
			<Divider type="horizontal"
				orientation="left"
				style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				Подменю
			</Divider>
			<Menu
				mode="inline"
				defaultSelectedKeys={[active]}
				selectedKeys={[active]}
				// defaultOpenKeys={['sub1']}
				style={{ border: "none" }}
				inlineIndent={10}
				onClick={change}
			>
				{elements}
			</Menu>
		</>
	)
}
function MenuLevelThree({ active, menu, onChange }) {
	if (menu.length <= 0) return (<></>);
	const style = {
		marginBottom: "0px",
		marginTop: "0px",
		fontSize: "13px",
		paddingRight: "10px"
	}
	const l = (element, key) => {
		const count = (element.badge) ? element.badge(element).count : 0;
		const icon = (element.icon) ? element.icon(element) : <></>;
		return (
			<Menu.Item style={style} key={key}>
				<Tooltip title={element.name} mouseEnterDelay={0.8}>
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
							{icon}{element.name}
						</div>
						<div style={{ width: "37px", textAlign: "right" }}>
							{/* {count > 0 && <Badge color="#ff4d4f" />} */}
							<Badge count={count} overflowCount={99} />
						</div>
					</div>
				</Tooltip>
			</Menu.Item>
		)
	}
	const elements = menu.map((element, index) => {
		const key = element.uuid || element.key || index;
		if (element.group) {
			const ui = element.group.map(e => {
				return l(e, e.uuid)
			})
			return (
				<SubMenu
					key={element.uuid}
					title={<span style={style}>{element.title}</span>}
					inlineIndent={0}
				>
					{ui}
				</SubMenu>

				// <Menu.ItemGroup title={
				// 	<>
				// 		{/* <Menu.Divider></Menu.Divider> */}
				// 		{element.title && <Divider type="horizontal"
				// 			orientation="left"
				// 			style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				// 			{element.title}
				// 		</Divider>}
				// 	</>} key={key}>
				// 	{ui}
				// </Menu.ItemGroup>
			)
		} else {
			return l(element, key)
		}
	})
	const change = ({ key }) => {
		onChange(key, menu)
	}
	return (
		<>
			<Divider type="horizontal"
				orientation="left"
				style={{ margin: "12px 0", fontSize: "13px", fontWeight: "600", padding: "0px 15px 0px 5px" }} >
				Закладки
			</Divider>
			<Menu
				mode="inline"
				defaultSelectedKeys={[active]}
				selectedKeys={[active]}
				// defaultOpenKeys={['sub1']}
				style={{ border: "none" }}
				inlineIndent={10}
				onClick={change}
			>
				{elements}
			</Menu>
		</>
	)
}

function Home(props) {
	let navigate = useNavigate();
	let location = useLocation();
	const auth = useAuth();
	const dispatch = useDispatch();
	const user = useSelector(state => state.home.user);
	const meta = useSelector(state => state.meta);

	useEffect(
		() => {
			auth.fetch('/api/meta').then(res => {
				if (res && res.data && dispatch) {
					dispatch({ type: 'META', payload: res.data })
				}
			});
			auth.fetch('/api/iam').then(res => {
				if (res && res.data) {
					dispatch({ type: 'USER', payload: res.data })
				}
			});
		},
		[auth, dispatch]
	);

	const logout = () => {
		auth.logout(() => {
			navigate('/');
		});
	}
	const logoutall = (e) => {
		e.stopPropagation();
		e.preventDefault();
		confirm({
			title: 'Вы действительно хотите выйти на всех устройствах?',
			icon: <Icofont icon="logout" style={{ color: "red" }} />,
			content: <span style={{ fontSize: "12px" }}>На всех подключенных устройствах будет отменена текущая сессия аутентификации и потребуется повторно ввести логин и пароль для породолжения работы</span>,
			okText: 'Выйти',
			cancelText: 'Отмена',
			onOk() {
				auth.logoutall(() => {
					navigate('/');
				});
			},
			onCancel() {
			},
		})
	}
	const menu = () => {
		let menu = [];
		menu.push({
			key: 'web',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {"Главный сайт"}</div>
			</a>),
		});
		menu.push({
			key: 'lk',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="home" style={{ paddingRight: "8px", color: "orange" }} />{"Личный кабинет"}</div>
			</a>),
		});
		menu.push({
			key: 'jack',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="ui-calendar" style={{ paddingRight: "8px", color: "green" }} /> {"Войти в мероприятие"}</div>
			</a>),
		});
		if (HasRole(user, "root") || HasRole(user, "admin")) {
			menu.push({
				type: 'divider',
			});
			menu.push({
				key: 'admin',
				label: (<NavLink to="admin">
					{({ isActive }) =>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<div><Icofont icon="settings" style={{ paddingRight: "8px", color: (isActive) ? "#1890ff" : "black" }} />Администрирование</div>
							<div style={{ flex: 0 }} onClick={() => { }}></div>
						</div>
					}
				</NavLink>),
			});
		}
		// menu.push({
		// 	key: 'profile',
		// 	label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`} style={{ display: "flex", justifyContent: "space-between" }}>
		// 		<div><Icofont icon="user" /> {t("Профиль")}</div>
		// 	</a>),
		// });
		menu.push({
			type: 'divider',
		});
		// if (isAnyFederationAdministrator(user)) {
		// 	menu.push({
		// 		key: '1',
		// 		label: (<NavLink to="settings">
		// 			{({ isActive }) =>
		// 				<div style={{ display: "flex", justifyContent: "space-between" }}>
		// 					<div><Icofont icon="settings" style={{ paddingRight: "8px", color: (isActive) ? "#1890ff" : "black" }} />Настройки</div>
		// 					<div style={{ flex: 0 }} onClick={() => { }}></div>
		// 				</div>
		// 			}
		// 		</NavLink>),
		// 	});
		// }
		menu.push({
			key: 'logout',
			label: (
				<div style={{ display: "flex", justifyContent: "space-between" }} onClick={logout}>
					<div><LogoutOutlined /> Выход</div>
					<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
						<Tooltip title="Выйти на всех устройствах">
							<Icofont icon="logout" />
						</Tooltip>
					</div>
				</div>
			),
		});
		return menu;
	}

	return (
		<div>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<Layout>
						<Header className="header" style={{ backgroundColor: "white" }}>
							<div style={{ width: "1000px", margin: "0 auto" }}>
								<div style={{ float: "left" }}>
									<a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)} className="logo"></a>
								</div>
								<div style={{ float: "right" }}>
									<Dropdown overlay={
										<div style={{ color: "white", borderRadius: "4px" }}>
											<Menu items={menu()} />
										</div>}>
										<div style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
											<div style={{ lineHeight: "20px", textAlign: "right", paddingRight: "15px" }}>
												<div style={{ fontWeight: "600", fontSize: "14px" }}>{user.lastname} {user.firstname}</div>
												<div style={{ fontSize: "12px" }}>{user.email}</div>
											</div>
											<div>
												<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
												{/* <Avatar shape="square" size="large" icon={(user.avatarMin) ? <Image
													width={40}
													height={40}
													style={{ background: "transparent"}}
													preview={false}
													src={(user.avatarMin)? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin:"error"}
													fallback="data:image/png;base64,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"
												/> : <UserOutlined style={{color: "gray"}} />} /> */}
											</div>
										</div>
									</Dropdown>
								</div>
							</div>
						</Header>
						<Content style={{ padding: '25px 25px 0 25px' }}>
							<Layout style={{ width: "1000px", margin: "0 auto" }}>
								<Content style={{ minHeight: 600, padding: "0px 0px 0px 12px" }}>
									<Routes>
										<Route index element={<CommonProfile {...props} />} />
										<Route exact path="/common/profile" element={<CommonProfile {...props} />} />
										{(HasRole(user, "root") || HasRole(user, "admin")) && <Route exact path="/admin" element={<Admin {...props} />} />}
									</Routes>
								</Content>
							</Layout>
						</Content>
						<Footer style={{ textAlign: 'center' }}>
							<div>Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"</div>
						</Footer>
					</Layout>
				</UserContext.Provider>
			</MetaContext.Provider>
		</div>
	);
};

export default Home;